import { TourConfig } from "@/types/tour"
import { standardOffset } from "./utils/floatingUIConfigs"
import { ensureRoute } from "./utils/routeNavigation"
import WelcomeStep from "./steps/visual_variable/WelcomeStep.vue"
import CssSelectorStep from "./steps/visual_variable/CssSelectorStep.vue"
import VariationsStep from "./steps/visual_variable/VariationsStep.vue"
import TourCompleteStep from "./steps/visual_variable/TourCompleteStep.vue"
import { componentAsHtml } from "./utils/componentAsHtml"

/**
 * Tour configuration for the Visual Variable creation page
 */
export const visualVariableTour: TourConfig = {
   id: "visual_variable_tour",
   humanReadableName: "Visual Variable Tour",
   waitForElements: true,
   skippable: true,
   options: {
      useModalOverlay: true,
      defaultStepOptions: {
         classes: "q-card q-dark-transition shepherd-theme-quasar",
         arrow: true,
         scrollTo: { behavior: "smooth", block: "center" },
      },
   },
   steps: [
      {
         id: "welcome",
         title: "Welcome to Visual Variables",
         text: componentAsHtml(WelcomeStep),
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         beforeShowPromise: ensureRoute("CreateVisualVariable"),
      },
      {
         id: "human-readable-name",
         title: "Human Readable Name",
         text: `Name your variable clearly so your team knows what visual element it's optimizing—e.g., "Header Button Color" or "Hero Image Variant".`,
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "[data-tour='human-readable-name-field']",
            on: "right",
         },
         floatingUIOptions: standardOffset,
         beforeShowPromise: ensureRoute("CreateVisualVariable"),
      },
      {
         id: "action-type",
         title: "Select Action Type",
         text: `Choose what you want to modify. Popular options include: "Set Text" for headings, "Set Background Color" for styling, "Set Src" for images, or "Set Style" for custom CSS. This determines what change the Visual Editor will make to the element you select.`,
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "[data-tour='action-field']",
            on: "right",
         },
         floatingUIOptions: standardOffset,
         beforeShowPromise: ensureRoute("CreateVisualVariable"),
      },
      {
         id: "css-selector",
         title: "CSS Selector",
         text: componentAsHtml(CssSelectorStep),
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "[data-tour='css-selector-field']",
            on: "right",
         },
         floatingUIOptions: standardOffset,
         beforeShowPromise: ensureRoute("CreateVisualVariable"),
      },
      {
         id: "variations",
         title: "Create Variations",
         text: componentAsHtml(VariationsStep),
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "[data-tour='allowed-values-field']",
            on: "right",
         },
         floatingUIOptions: standardOffset,
         beforeShowPromise: ensureRoute("CreateVisualVariable"),
      },
      {
         id: "tour-complete",
         title: "Ready to Create!",
         text: componentAsHtml(TourCompleteStep),
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  if (this.complete) return this.complete()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Complete",
            },
         ],
         floatingUIOptions: standardOffset,
         beforeShowPromise: ensureRoute("CreateVisualVariable"),
      },
   ],
}
